function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCosto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 84 84",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M43.054,8.333c-19.096,0 -34.721,15.625 -34.721,34.721c0,19.1 15.625,34.725 34.721,34.725c19.1,0 34.725,-15.625 34.725,-34.725c0,-19.096 -15.625,-34.721 -34.725,-34.721Zm0,62.5c-15.312,0 -27.775,-12.466 -27.775,-27.779c0,-15.312 12.463,-27.775 27.775,-27.775c15.313,0 27.779,12.463 27.779,27.775c0,15.313 -12.466,27.779 -27.779,27.779Zm10.952,-36.842l-7.072,1.22c-0.355,-0.979 -0.675,-1.658 -0.96,-2.037c-0.285,-0.379 -0.757,-0.761 -1.416,-1.147l-0,5.975c3.853,1.116 6.425,2.294 7.718,3.535c1.711,1.667 2.566,3.783 2.566,6.347c0,1.502 -0.307,2.88 -0.922,4.134c-0.615,1.255 -1.4,2.302 -2.357,3.143c-0.957,0.84 -1.974,1.45 -3.051,1.829c-1.077,0.379 -2.395,0.603 -3.954,0.672l-0,3.908l-2.775,-0l-0,-3.908c-1.863,-0.179 -3.375,-0.506 -4.534,-0.982c-1.16,-0.475 -2.161,-1.133 -3.004,-1.974c-0.842,-0.841 -1.492,-1.747 -1.948,-2.719c-0.456,-0.971 -0.798,-2.146 -1.027,-3.525l7.68,-0.971c0.228,1.364 0.536,2.35 0.922,2.956c0.387,0.607 1.024,1.144 1.911,1.613l-0,-7.298c-2.56,-0.772 -4.376,-1.44 -5.447,-2.006c-1.07,-0.565 -1.999,-1.471 -2.784,-2.718c-0.786,-1.247 -1.179,-2.767 -1.179,-4.559c-0,-2.453 0.789,-4.503 2.367,-6.15c1.577,-1.647 3.925,-2.56 7.043,-2.739l-0,-2.047l2.775,-0l-0,2.047c2.839,0.193 5.009,0.923 6.511,2.191c1.501,1.268 2.48,3.005 2.937,5.21Zm-9.448,18.275c1.077,-0.261 1.866,-0.692 2.367,-1.292c0.5,-0.599 0.751,-1.271 0.751,-2.015c-0,-0.648 -0.213,-1.244 -0.637,-1.789c-0.425,-0.544 -1.252,-1.051 -2.481,-1.519l-0,6.615Zm-2.775,-20.343c-0.811,0.29 -1.375,0.648 -1.692,1.075c-0.317,0.428 -0.475,0.931 -0.475,1.51c-0,0.606 0.161,1.133 0.484,1.581c0.323,0.448 0.884,0.824 1.683,1.127l-0,-5.293Z",
    style: {
      fill: "#1565c0",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosto);
export default __webpack_public_path__ + "static/media/costo.69bce4e93451b4951d50b32cf55daa79.svg";
export { ForwardRef as ReactComponent };